define("shared/components/shared/linkinbio/modal/multi-link", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@ember/object", "@glimmer/tracking", "@ember/utils", "shared/utils/image-tag", "later/utils/is-valid-url", "later/utils/compare-strings", "shared/utils/constants/linkinbio-block-types"], function (_exports, _component, _templateFactory, _component2, _service, _object, _tracking, _utils, _imageTag, _isValidUrl, _compareStrings, _linkinbioBlockTypes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/object",0,"@glimmer/tracking",0,"@ember/utils",0,"shared/utils/image-tag",0,"later/utils/is-valid-url",0,"later/utils/compare-strings",0,"shared/utils/constants/linkinbio-block-types",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{this.clickOutside}} {{did-insert this.setup}} as |modal| >
    <modal.card class="cDT--modal">
      <div class="cDT--modal__mediaWrapper">
        <div class="cTG--tagWrapper eLB--modal__image">
          <img
            class="o--media cDT--modal__media"
            src={{if @post.firstPostMediaItem.previewUrl @post.firstPostMediaItem.previewUrl this.linkinbioPost.highResOrProcessingUrl}}
            data-test-id="image"
          >
        </div>
      </div>
      {{#if this.editingLink}}
        <div class="cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0">
          <modal.card-header class="u--p__tb__md">
            <p class="o--modalHeader__title">
              {{#if this.addNewLink}}
                <Shared::Ui::Button
                  @class="u--float--left"
                  @type="unstyled"
                  @onClick={{this.cancelAddLink}}
                >
                  {{svg-jar "arrow-left" class="o--icon--md o--icon--hl u--m__r__md u--m__t__sm qa--linkinbio_left_arrow"}}
                </Shared::Ui::Button>
                {{t "linkinbio.multi_link.add_link"}}
              {{else}}
                <Shared::Ui::Button
                  @class="u--float--left"
                  @type="unstyled"
                  @onClick={{this.cancelEditLink}}
                >
                  {{svg-jar "arrow-left" class="o--icon--md o--icon--hl u--m__r__md u--m__t__sm qa--linkinbio_left_arrow"}}
                </Shared::Ui::Button>
                {{t "linkinbio.multi_link.edit_link"}}
              {{/if}}
            </p>
            <p class="u--text--sm">
              {{t "linkinbio.multi_link.adjust_location"}}
            </p>
          </modal.card-header>
  
          <section class="o--modalBody--secondary has--footer">
            <div class="o--formWrapper">
              <label>
                {{t "linkinbio.multi_link.link_title"}}
              </label>
              <Input
                @type="text"
                required={{true}}
                class="o--form__input qa--linkinbio_text_input"
                placeholder={{t "linkinbio.multi_link.link_title"}}
                @value={{this.selectedLink.title}}
              />
            </div>
            <div class="o--formWrapper">
              <label>
                {{t "linkinbio.multi_link.link_url"}}
              </label>
              <Input
                @type="text"
                required={{true}}
                class="o--form__input qa--linkinbio_url_input"
                placeholder={{t "linkinbio.multi_link.link_url"}}
                @value={{this.selectedLink.linkUrl}}
              />
            </div>
          </section>
  
          <modal.card-footer>
            {{#if this.addNewLink}}
              <button
                class="o--btn o--btn--outline o--btn--block qa--linkinbio_add_link
                  {{if this.isValidMultiLink "" "o--btn--disabled"}}"
                type="button"
                {{on "click" (fn this.commitPoint this.selectedLink)}}
              >
                {{t "linkinbio.multi_link.save_link"}}
              </button>
            {{else}}
              <button
                class="o--btn o--btn--mute u--float--left"
                type="button"
                {{on "click" (fn this.toggleDeleteLink this.selectedLink)}}
              >
                {{t "linkinbio.multi_link.remove_link"}}
              </button>
              <button
                class="o--btn o--btn--outline u--float--right
                  {{if this.isValidMultiLink "" "o--btn--disabled"}}"
                type="button"
                {{on "click" (fn this.commitPoint this.selectedLink)}}
              >
                {{t "linkinbio.multi_link.update_link"}}
              </button>
            {{/if}}
          </modal.card-footer>
        </div>
      {{else}}
        <div class="cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0">
          <div class="o--modalHeader u--p__t__md">
            <p class="o--modalHeader__title u--float--left">
              {{t "linkinbio.multi_link.external_links"}}
            </p>
  
            <span class="u--float--right">
              <BasicDropdown as |emberDrop|>
                <emberDrop.Trigger>
                  <span class="u--text--dark">
                    <EmberTooltip @event="hover" @delay={{330}} @side="left">
                      {{t "shopify.modal_list.switch.hint"}}
                    </EmberTooltip>
                    {{svg-jar "ellipsis-h-solid" class="o--icon"}}
                  </span>
                </emberDrop.Trigger>
                <emberDrop.Content>
                  <div class="o--dropWrapper--sm">
                    <div class="o--dropHeader">
                      <h4 class="o--dropHeader__title">
                        {{t "shopify.modal_list.switch_to_shopify.title"}}
                      </h4>
                      <p>
                        {{t "shopify.modal_list.switch_to_shopify.subtitle"}}
                      </p>
                    </div>
                    <hr class="u--m__tb__0">
                    <div class="o--dropBody">
                      <Shared::Ui::Button
                        @additional="block"
                        @text={{t "shopify.modal_list.switch.btn_cta"}}
                        @type="outline"
                        @onClick={{this.toggleSwitchToShopifyModal}}
                      />
                    </div>
                  </div>
                </emberDrop.Content>
              </BasicDropdown>
            </span>
  
  
          </div>
  
          <Shared::Linkinbio::List::MultiLink
            @links={{this.sortedLinks}}
            @canAddNewLink={{this.canAddNewLink}}
            @editLink={{this.editLink}}
            @addLink={{this.addLink}}
            @toggleDeleteLink={{this.toggleDeleteLink}}
          />
  
          <modal.card-footer>
            {{#if @handleSave}}
              <Shared::Ui::Button
                class="qa--multiLink_saveBtn"
                @type="primary"
                @additional="block"
                @isDisabled={{this.isLoading}}
                @text={{t "shared_phrases.save_changes"}}
                @onClick={{this.closeModalWithSave}}
              />
            {{else}}
              <Shared::Ui::Button
                class="qa--multiLink_doneBtn"
                @type="outline"
                @additional="block"
                @text={{t "shared_words.done"}}
                @onClick={{fn this.closeModal false}}
              />
            {{/if}}
          </modal.card-footer>
        </div>
      {{/if}}
    </modal.card>
  </Shared::Modal>
  
  */
  {
    "id": "IsO6T8lY",
    "block": "[[[8,[39,0],[[4,[38,1],[[30,0,[\"setup\"]]],null]],[[\"@close\"],[[30,0,[\"clickOutside\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"cDT--modal\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"cDT--modal__mediaWrapper\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cTG--tagWrapper eLB--modal__image\"],[12],[1,\"\\n        \"],[10,\"img\"],[14,0,\"o--media cDT--modal__media\"],[15,\"src\",[52,[30,2,[\"firstPostMediaItem\",\"previewUrl\"]],[30,2,[\"firstPostMediaItem\",\"previewUrl\"]],[30,0,[\"linkinbioPost\",\"highResOrProcessingUrl\"]]]],[14,\"data-test-id\",\"image\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"editingLink\"]],[[[1,\"      \"],[10,0],[14,0,\"cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0\"],[12],[1,\"\\n        \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__tb__md\"]],null,[[\"default\"],[[[[1,\"\\n          \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n\"],[41,[30,0,[\"addNewLink\"]],[[[1,\"              \"],[8,[39,3],null,[[\"@class\",\"@type\",\"@onClick\"],[\"u--float--left\",\"unstyled\",[30,0,[\"cancelAddLink\"]]]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,4],[\"arrow-left\"],[[\"class\"],[\"o--icon--md o--icon--hl u--m__r__md u--m__t__sm qa--linkinbio_left_arrow\"]]]],[1,\"\\n              \"]],[]]]]],[1,\"\\n              \"],[1,[28,[35,5],[\"linkinbio.multi_link.add_link\"],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[8,[39,3],null,[[\"@class\",\"@type\",\"@onClick\"],[\"u--float--left\",\"unstyled\",[30,0,[\"cancelEditLink\"]]]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,4],[\"arrow-left\"],[[\"class\"],[\"o--icon--md o--icon--hl u--m__r__md u--m__t__sm qa--linkinbio_left_arrow\"]]]],[1,\"\\n              \"]],[]]]]],[1,\"\\n              \"],[1,[28,[35,5],[\"linkinbio.multi_link.edit_link\"],null]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--text--sm\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"linkinbio.multi_link.adjust_location\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n\\n        \"],[10,\"section\"],[14,0,\"o--modalBody--secondary has--footer\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"linkinbio.multi_link.link_title\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,6],[[16,\"required\",true],[24,0,\"o--form__input qa--linkinbio_text_input\"],[16,\"placeholder\",[28,[37,5],[\"linkinbio.multi_link.link_title\"],null]]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"selectedLink\",\"title\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n            \"],[10,\"label\"],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"linkinbio.multi_link.link_url\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[8,[39,6],[[16,\"required\",true],[24,0,\"o--form__input qa--linkinbio_url_input\"],[16,\"placeholder\",[28,[37,5],[\"linkinbio.multi_link.link_url\"],null]]],[[\"@type\",\"@value\"],[\"text\",[30,0,[\"selectedLink\",\"linkUrl\"]]]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"addNewLink\"]],[[[1,\"            \"],[11,\"button\"],[16,0,[29,[\"o--btn o--btn--outline o--btn--block qa--linkinbio_add_link\\n                \",[52,[30,0,[\"isValidMultiLink\"]],\"\",\"o--btn--disabled\"]]]],[24,4,\"button\"],[4,[38,7],[\"click\",[28,[37,8],[[30,0,[\"commitPoint\"]],[30,0,[\"selectedLink\"]]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"linkinbio.multi_link.save_link\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[11,\"button\"],[24,0,\"o--btn o--btn--mute u--float--left\"],[24,4,\"button\"],[4,[38,7],[\"click\",[28,[37,8],[[30,0,[\"toggleDeleteLink\"]],[30,0,[\"selectedLink\"]]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"linkinbio.multi_link.remove_link\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[11,\"button\"],[16,0,[29,[\"o--btn o--btn--outline u--float--right\\n                \",[52,[30,0,[\"isValidMultiLink\"]],\"\",\"o--btn--disabled\"]]]],[24,4,\"button\"],[4,[38,7],[\"click\",[28,[37,8],[[30,0,[\"commitPoint\"]],[30,0,[\"selectedLink\"]]],null]],null],[12],[1,\"\\n              \"],[1,[28,[35,5],[\"linkinbio.multi_link.update_link\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"cDT--modal__infoWrapper u--p__lr__0 u--p__tb__0\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--modalHeader u--p__t__md\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"o--modalHeader__title u--float--left\"],[12],[1,\"\\n            \"],[1,[28,[35,5],[\"linkinbio.multi_link.external_links\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[10,1],[14,0,\"u--float--right\"],[12],[1,\"\\n            \"],[8,[39,9],null,null,[[\"default\"],[[[[1,\"\\n              \"],[8,[30,3,[\"Trigger\"]],null,null,[[\"default\"],[[[[1,\"\\n                \"],[10,1],[14,0,\"u--text--dark\"],[12],[1,\"\\n                  \"],[8,[39,10],null,[[\"@event\",\"@delay\",\"@side\"],[\"hover\",330,\"left\"]],[[\"default\"],[[[[1,\"\\n                    \"],[1,[28,[35,5],[\"shopify.modal_list.switch.hint\"],null]],[1,\"\\n                  \"]],[]]]]],[1,\"\\n                  \"],[1,[28,[35,4],[\"ellipsis-h-solid\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n              \"],[8,[30,3,[\"Content\"]],null,null,[[\"default\"],[[[[1,\"\\n                \"],[10,0],[14,0,\"o--dropWrapper--sm\"],[12],[1,\"\\n                  \"],[10,0],[14,0,\"o--dropHeader\"],[12],[1,\"\\n                    \"],[10,\"h4\"],[14,0,\"o--dropHeader__title\"],[12],[1,\"\\n                      \"],[1,[28,[35,5],[\"shopify.modal_list.switch_to_shopify.title\"],null]],[1,\"\\n                    \"],[13],[1,\"\\n                    \"],[10,2],[12],[1,\"\\n                      \"],[1,[28,[35,5],[\"shopify.modal_list.switch_to_shopify.subtitle\"],null]],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,\"hr\"],[14,0,\"u--m__tb__0\"],[12],[13],[1,\"\\n                  \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n                    \"],[8,[39,3],null,[[\"@additional\",\"@text\",\"@type\",\"@onClick\"],[\"block\",[28,[37,5],[\"shopify.modal_list.switch.btn_cta\"],null],\"outline\",[30,0,[\"toggleSwitchToShopifyModal\"]]]],null],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"]],[3]]]]],[1,\"\\n          \"],[13],[1,\"\\n\\n\\n        \"],[13],[1,\"\\n\\n        \"],[8,[39,11],null,[[\"@links\",\"@canAddNewLink\",\"@editLink\",\"@addLink\",\"@toggleDeleteLink\"],[[30,0,[\"sortedLinks\"]],[30,0,[\"canAddNewLink\"]],[30,0,[\"editLink\"]],[30,0,[\"addLink\"]],[30,0,[\"toggleDeleteLink\"]]]],null],[1,\"\\n\\n        \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,4],[[[1,\"            \"],[8,[39,3],[[24,0,\"qa--multiLink_saveBtn\"]],[[\"@type\",\"@additional\",\"@isDisabled\",\"@text\",\"@onClick\"],[\"primary\",\"block\",[30,0,[\"isLoading\"]],[28,[37,5],[\"shared_phrases.save_changes\"],null],[30,0,[\"closeModalWithSave\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,3],[[24,0,\"qa--multiLink_doneBtn\"]],[[\"@type\",\"@additional\",\"@text\",\"@onClick\"],[\"outline\",\"block\",[28,[37,5],[\"shared_words.done\"],null],[28,[37,8],[[30,0,[\"closeModal\"]],false],null]]],null],[1,\"\\n\"]],[]]],[1,\"        \"]],[]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"]],[1]]]]],[1,\"\\n\"]],[\"modal\",\"@post\",\"emberDrop\",\"@handleSave\"],false,[\"shared/modal\",\"did-insert\",\"if\",\"shared/ui/button\",\"svg-jar\",\"t\",\"input\",\"on\",\"fn\",\"basic-dropdown\",\"ember-tooltip\",\"shared/linkinbio/list/multi-link\"]]",
    "moduleName": "shared/components/shared/linkinbio/modal/multi-link.hbs",
    "isStrictMode": false
  });

  let MultiLinkModalComponent = (_class = class MultiLinkModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "router", _descriptor4, this);

      _initializerDefineProperty(this, "store", _descriptor5, this);

      _defineProperty(this, "maxNumLinks", 5);

      _initializerDefineProperty(this, "addNewLink", _descriptor6, this);

      _initializerDefineProperty(this, "editingLink", _descriptor7, this);

      _initializerDefineProperty(this, "imageTag", _descriptor8, this);

      _initializerDefineProperty(this, "isLoading", _descriptor9, this);

      _initializerDefineProperty(this, "rollbackData", _descriptor10, this);

      _initializerDefineProperty(this, "savingPostLink", _descriptor11, this);

      _initializerDefineProperty(this, "selectedLink", _descriptor12, this);
    }

    get canAddNewLink() {
      var _this$filteredLinks;

      return ((_this$filteredLinks = this.filteredLinks) === null || _this$filteredLinks === void 0 ? void 0 : _this$filteredLinks.length) < this.maxNumLinks;
    }

    get hasUnsavedLinks() {
      return this.linkinbioLinkList.any(link => link.get('hasDirtyAttributes'));
    }

    get isValidMultiLink() {
      return (0, _isValidUrl.isValidUrl)((0, _object.get)(this.selectedLink, 'linkUrl')) && (0, _utils.isPresent)((0, _object.get)(this.selectedLink, 'title')) && !this.savingPostLink;
    }

    get linkinbioLinkList() {
      return this.linkinbioPost.get('linkinbioPostLinks');
    }

    get linkinbioPost() {
      return this.args.linkinbioPost;
    }

    get filteredLinks() {
      return this.linkinbioLinkList.filter(link => !link.isDeleted);
    }

    get sortedLinks() {
      return this.filteredLinks.sort((linkA, linkB) => {
        const idA = linkA.id;
        const idB = linkB.id;

        if (!idA && !idB) {
          return linkA.createdTime - linkB.createdTime;
        }

        if (!idA) {
          return 1;
        }

        if (!idB) {
          return -1;
        }

        return idA - idB;
      });
    }

    addLink() {
      this.editingLink = true;
      this.addNewLink = true;
      this.selectedLink = {};
      this.imageTag.enableNewPoints();
      this.imageTag.newPoint();
    }

    cancelAddLink() {
      var _this$selectedLink;

      const point = this.imageTag.getPointById((_this$selectedLink = this.selectedLink) === null || _this$selectedLink === void 0 ? void 0 : _this$selectedLink.id);
      this.imageTag.removePoint(point);
      this.imageTag.disableNewPoints();
      this.editingLink = false;
      this.addNewLink = false;
      this.selectedLink = {};
    }

    cancelEditLink() {
      var _this$rollbackData, _this$rollbackData2;

      this.editingLink = false;
      const link = this.selectedLink;
      const id = link.get('id') || link.get('createdAt');
      link.title = (_this$rollbackData = this.rollbackData) === null || _this$rollbackData === void 0 ? void 0 : _this$rollbackData.title;
      link.linkUrl = (_this$rollbackData2 = this.rollbackData) === null || _this$rollbackData2 === void 0 ? void 0 : _this$rollbackData2.linkUrl;
      this.rollbackData = {}; //Note: Rollback Changes to Point Position

      const point = this.imageTag.getPointById(id);
      this.imageTag.positionPoint(point, this.formatPoint(link));
      this.imageTag.saveAllPoints();
      this.imageTag.disableNewPoints();
    }

    clickOutside() {
      if (this.hasUnsavedLinks) {
        this.dialogManager.confirm(this.intl.t('shared_phrases.close_warning'), {
          description: this.intl.t('shared_phrases.changes_not_saved'),
          confirmButton: this.intl.t('shared_words.leave')
        }).then(() => this.closeModal()).catch(() => {});
      } else {
        this.closeModal(Boolean(this.args.handleSave));
      }
    }

    closeModal() {
      let rollback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (rollback) {
        this.store.peekAll('linkinbio-post-link').filter(link => link.get('linkinbioPost.id') === this.linkinbioPost.get('id')).forEach(link => link.rollbackAttributes());
      }

      document.querySelector('.eLB--modal__image').removeEventListener('click', this.clickTagEventHandler.bind(this));
      this.args.togglePostModal('multilink');
    }

    async closeModalWithSave() {
      this.isLoading = true;
      await this.args.handleSave.perform(this.linkinbioPost, () => {
        this.closeModal();
        this.isLoading = false;
      });

      if (!this.linkinbioPost.hasMultiLinks) {
        this.router.transitionTo({
          queryParams: {
            tab: 'blocks',
            block: _linkinbioBlockTypes.default.FEED_LIST,
            blockId: null,
            postId: null,
            postType: null,
            feedType: null,
            view: null
          }
        });
      }
    }

    commitPoint(link) {
      const point = this.imageTag.getActivePoint();

      if (link.set) {
        link.set('x', point.x);
        link.set('y', point.y);
      } else {
        this.store.createRecord('linkinbio-post-link', {
          x: point.x,
          y: point.y,
          title: link.title,
          linkUrl: link.linkUrl,
          linkinbioPost: this.linkinbioPost,
          createdAt: Date.now()
        });
      }

      this.savingPostLink = false;
      this.editingLink = false;
      this.addNewLink = false;
      this.selectedLink = {}; // Temp fix: Re-seed after every save, to fix "id" no updating on new point save

      this.seedPoints();
      this.imageTag.disableNewPoints();
    }

    deletePostLink(link) {
      link.deleteRecord();
      this.seedPoints();
      this.editingLink = false;
      this.addNewLink = false;
      this.selectedLink = {};
    }

    destroyPost() {
      this.store.peekAll('linkinbio-post-link').filter(link => link.get('linkinbioPost.id') === this.linkinbioPost.get('id')).forEach(link => {
        this.deletePostLink(link);
      });
      this.args.toggleTypeSelectorModal();
    }

    editLink(link) {
      this.editingLink = true;
      this.selectedLink = link;
      this.imageTag.enableNewPoints();
      this.rollbackData = {
        title: link.get('title'),
        linkUrl: link.get('linkUrl')
      };
      const id = link.get('id') || link.get('createdAt');
      const point = this.imageTag.getPointById(id);
      this.imageTag.setActivePoint(point);
    }

    setup() {
      this.initImageTag(); // Go to create link view automatically

      if (this.sortedLinks.length === 0) {
        const img = document.querySelector('.eLB--modal__image img');

        const loadHandler = () => {
          if (this.isDestroying) {
            return;
          }

          this.addLink();
          this.selectedLink = {
            linkUrl: this.linkinbioPost.linkUrl,
            title: ''
          };

          if (this.linkinbioPost.get('isNew')) {
            this.linkinbioPost.linkUrl = null;
          }

          img.removeEventListener('load', loadHandler);
        };

        img.addEventListener('load', loadHandler);
      }

      document.querySelector('.eLB--modal__image').addEventListener('click', this.clickTagEventHandler.bind(this));
    }

    toggleDeleteLink(link) {
      this.selectedLink = link;
      this.dialogManager.confirm(this.intl.t('linkinbio.multi_link.confirm_delete'), {
        confirmButton: this.intl.t('shared_words.remove')
      }).then(() => this.deletePostLink(link));
    }

    toggleSwitchToShopifyModal() {
      this.dialogManager.confirm(this.intl.t('shopify.modal_list.switch_to_shopify.confirm_title'), {
        description: this.intl.t('shopify.modal_list.switch_to_shopify.confirm_description'),
        confirmButton: this.intl.t('shopify.modal_list.switch_to_shopify.confirm_button')
      }).then(() => this.destroyPost());
    }

    initImageTag() {
      this.imageTag = new _imageTag.default('.eLB--modal__image', {
        className: 'cTG--tag',
        pointTextClassName: 'cTG--tag__point',
        activeClassName: 'is--active'
      });
      this.seedPoints();
      this.imageTag.disableNewPoints();
    }

    seedPoints() {
      const seedData = this.sortedLinks.map((link, idx) => this.formatPoint(link, idx + 1));
      this.imageTag.seedPoints(seedData);
    }

    formatPoint(emberObject, text) {
      return {
        id: emberObject.get('id') || emberObject.get('createdAt'),
        // createdAt is used for unsaved/new links
        x: emberObject.get('x'),
        y: emberObject.get('y'),
        text
      };
    }

    findAncestor(el, cls) {
      let element = el;

      while ((element = element.parentElement) && !element.classList.contains(cls));

      return element;
    }

    clickTagEventHandler(event) {
      if (this.imageTag.getActivePoint()) {
        return;
      }

      const tag = this.findAncestor(event.target, 'cTG--tag');

      if (tag) {
        const tagId = tag.className.split(' ').find(classname => classname.includes('cTG--tag-')).replace('cTG--tag-', '');
        const link = this.store.peekAll('linkinbio-post-link').find(link => (0, _compareStrings.areStringsEqual)(link.id, tagId) || (0, _compareStrings.areStringsEqual)(link.createdAt, tagId));
        this.editLink(link);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "addNewLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "editingLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "imageTag", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "rollbackData", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "savingPostLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "selectedLink", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return {};
    }
  }), _applyDecoratedDescriptor(_class.prototype, "addLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelAddLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelAddLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clickOutside", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clickOutside"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModalWithSave", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModalWithSave"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "commitPoint", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "commitPoint"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deletePostLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deletePostLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setup", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleDeleteLink", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleDeleteLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSwitchToShopifyModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSwitchToShopifyModal"), _class.prototype)), _class);
  _exports.default = MultiLinkModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MultiLinkModalComponent);
});